import { Modal } from "@mui/material";
import Styles from "./SelectParticipant.module.css";
import React, { useState } from "react";
import { Close, Delete } from "@mui/icons-material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { handleRemoveUser_api } from "../../../../Services/ReverseAuction/AlterApi";
import {
  ErrorMessage,
  SuccessMessage,
} from "../../../../commons/Toast/ErrorMessage";

const SelectParticipant = ({
  open,
  handleClose,
  list,
  selected,
  header,
  handleSelectList,
  type,
  editType,
  tenderId,
  participants,
  duplicate,
  handleRemoveParticipant,
  editClosed,
}) => {
  const [search, setSearch] = useState("");
  const [allList, setAllList] = useState(list || []);


  const handleSearch = (name) => {
    const filteredList = list.filter((item) =>
      (item.generatorName?.toLowerCase() || "").includes(name.toLowerCase())
    );
    setAllList(filteredList);
    setSearch(name);
  };

  const handleRemoveUser = async (ele) => {
    let res = await handleRemoveUser_api({
      tenderId,
      genId: allList?.filter((elem) => elem?.id === ele)?.[0]?.id,
    });
    if (res?.data?.code === 200) {
      SuccessMessage(res?.data?.message);
      handleRemoveParticipant(ele);
    } else {
      ErrorMessage(res?.data?.error || res?.data?.message);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.selectionModal}`}>
        <div className={`display_flex_row modalHeading ${Styles.modalHeading}`}>
          <div className="headingText">{header}</div>
          <Close
            style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
            onClick={handleClose}
          />
        </div>
        {type !== "view" && (
          <div className={Styles.searchMain}>
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>
        )}

        <div className={Styles.displayMainElem}>
          <div
            className={`display_flex_row tableHeading ${Styles.tableMainElem}`}
          >
            <div className="table_text_align_left">Sl.No.</div>
            <div className="table_text_align_left">Seller Name</div>
          </div>
          <div className={`scroll_bar_y ${Styles.detailsMainElem}`}>
            {participants?.map((ele, index) => (
              <div
                className={`display_flex_row tableDetails ${Styles.tableMainDetails}`}
              >
                <div className="display_flex_row_gap_8_only">
                  <Delete
                    style={{ fontSize: "14px", color: "red" }}
                    onClick={() => handleRemoveUser(ele)}
                  />

                  <div>{index + 1}</div>
                </div>
                <div className="table_text_align_left">
                  {
                    allList?.filter((elem) => elem?.id === ele)?.[0]
                      ?.generatorName
                  }
                </div>
              </div>
            ))}
            <div className={Styles.otherGenerator}>Others Generartors</div>
            {allList
              ?.filter((ele) => !participants?.includes(ele?.id))
              ?.map((ele, index) => (
                <div
                  className={`display_flex_row tableDetails ${Styles.tableMainDetails}`}
                  onClick={() => handleSelectList(ele?.id)}
                >
                  <div className="display_flex_row_gap_8_only">
                    <>
                      {type !== "view" && (
                        <>
                          {(
                            editType
                              ? editClosed?.includes(ele?.id)
                              : selected?.includes(ele?.id)
                          ) ? (
                            <CheckBoxIcon style={{ fontSize: "14px" }} />
                          ) : (
                            <CheckBoxOutlineBlankIcon
                              style={{ fontSize: "14px" }}
                            />
                          )}
                        </>
                      )}
                    </>

                    <div>{index + 1}</div>
                  </div>
                  <div className="table_text_align_left">
                    {ele?.generatorName || ele?.name}
                  </div>
                </div>
              ))}
          </div>
        </div>
        {type !== "view" && (
          <div className={`display_flex_row_gap_8 ${Styles.buttonMain}`}>
            <div className="activeButton_type_3" onClick={handleClose}>
              Cancel
            </div>
            <div className="activeButton" onClick={handleClose}>
              Done
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default SelectParticipant;
